export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Textured%20linen%20fabric%20backdrop%20in%20warm%20ochre%20and%20dusty%20rose%20tones%20with%20abstract%20organic%20shadow%20patterns%2C%20sophisticated%20art%20gallery%20wall%20aesthetic%2C%20soft%20diffused%20window%20light%20from%20left%20side%2C%20editorial%20photography%20background%2C%20elegant%20warm%20tonal%20composition%2C%20refined%20minimal%20atmosphere&width=1600&height=900&seq=cta-bg-v2-003&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-wider mb-4">
          CURATED PRODUCTS AWAIT
        </h2>
        <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
          Explore organized collections spanning shoes, streetwear, accessories, and more — all in one Superbuy Spreadsheet hub.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-white rounded-full font-label font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap group"
        >
          <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span>START SHOPPING NOW</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}